import { render, staticRenderFns } from "./Approved.vue?vue&type=template&id=319fca43&"
import script from "./Approved.vue?vue&type=script&lang=js&"
export * from "./Approved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports